import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('React render error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: '#0f0f0f',
          color: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
          fontFamily: 'sans-serif',
        }}>
          <div style={{ maxWidth: '600px', width: '100%' }}>
            <h1 style={{ color: '#1a5fb4', fontSize: '24px', marginBottom: '16px' }}>
              Rock&apos;n&apos;Rhein – Seite konnte nicht geladen werden
            </h1>
            <p style={{ color: '#9e9e9e', marginBottom: '24px', fontSize: '14px' }}>
              Ein Fehler ist aufgetreten. Bitte die Seite neu laden.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#1a5fb4',
                color: '#fff',
                border: 'none',
                padding: '12px 24px',
                cursor: 'pointer',
                fontSize: '14px',
                marginBottom: '24px',
              }}
            >
              Seite neu laden
            </button>
            <details style={{ color: '#666', fontSize: '12px' }}>
              <summary style={{ cursor: 'pointer', marginBottom: '8px' }}>Fehlerdetails</summary>
              <pre style={{
                background: '#1c1c1c',
                padding: '12px',
                overflowX: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
              }}>
                {this.state.error?.toString()}
                {'\n'}
                {this.state.error?.stack}
              </pre>
            </details>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
